/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const AddPanelCart64Icon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 64, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="AddPanelCart64Icon"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <g>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M19 19H23C24.1046 19 25 19.8954 25 21V23H41.5C42.3284 23 43 23.6716 43 24.5V28.9541C43 29.5825 42.6083 30.1443 42.0186 30.3616L26.0186 36.2563C25.0393 36.6171 24 35.8924 24 34.8488V21C24 20.4477 23.5523 20 23 20H19V19ZM25 24V34.8488C25 35.1967 25.3464 35.4382 25.6729 35.318L41.6729 29.4232C41.8694 29.3508 42 29.1635 42 28.9541V24.5C42 24.2239 41.7761 24 41.5 24H25Z"
              fill="currentColor"
            />
            <path
              d="M25.5 42C26.3284 42 27 41.3284 27 40.5C27 39.6716 26.3284 39 25.5 39C24.6716 39 24 39.6716 24 40.5C24 41.3284 24.6716 42 25.5 42Z"
              fill="currentColor"
            />
            <path
              d="M39.5 42C40.3284 42 41 41.3284 41 40.5C41 39.6716 40.3284 39 39.5 39C38.6716 39 38 39.6716 38 40.5C38 41.3284 38.6716 42 39.5 42Z"
              fill="currentColor"
            />
          </g>
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

AddPanelCart64Icon.tags = ['shopping', 'cart', 'add', 'basket', 'purchase'];

AddPanelCart64Icon.category = '64x64 (Add panel)';

AddPanelCart64Icon.iconSize = 64;
